/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useEffect, useState, useCallback, useContext,
    useRef,
} from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import IndentListSkeleton from '../IndentReport/indentlistSkeleton';
import InvoiceReportSkeleton from './indentReportSkeleton';
import InvoiceReportFilterModal from './FilterModal';
import ViewandDownloadModal from './ViewandDownloadModal';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import HeaderContext from '../../../Components/Context/HeaderContext';

function InvoiceReport() {
    const {
        SetSuccessMessage, SetErrorMessage, setcolorValue,
    } = useContext(HeaderContext);
    const [InvoiceReportList, setInvoiceReportList] = useState([]);
    const [threeplList, setThreeplList] = useState([]);
    const [isEditId, setisEditId] = useState('');
    const [sortType, setsortType] = useState('INVOICE_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [viewandDownloadModal, setViewandDownloadModal] = useState(false);
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState({});
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [Filter, setFilter] = useState({
        order_category: [],
        payment_status: [],
        date_range: [],
        plant_name: [],
        customer_code: [],
    });
    const [noteToolTip, setNoteToolTip] = useState('');

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data?.data?.success_status === true) {
            setThreeplList(data?.data?.Items);
        }
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleInvoiceReport = useCallback((() => {
        distributorService.MISInvoiceReport(currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            // if (response.error === false && response.data.success_status === true) {
            if (response?.data?.Items.length === 0) {
                setLoading(false);
                setEmptyData(true);
            } else {
                setEmptyData(false);
                setLoading(false);
            }
            setLoading(false);
            setInvoiceReportList(response?.data?.Items);
            setCurrentPage(response?.data?.current_page);
            setTotalPage(response?.data?.number_of_pages);
            // } else {
            //     setLoading(false);
            // }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleViewInvoiceDetails = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        if (!res?.error && res?.data?.success_status) {
            setViewInvoiceDetails(res?.data?.data);
        }
        setViewandDownloadModal(true);
    };
    const buttonRef = useRef(null);

    useEffect(() => {
        // Function to handle clicks outside the button
        function handleClickOutside(event) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setexportClick(false);
            }
        }

        // Add event listener to detect clicks outside the button
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener when the component is unmounted
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [buttonRef]);

    function isExceedingThreeMonths(date1, date2) {
        // const startDate = new Date(date1);
        // const endDate = new Date(date2);

        // // Calculate the difference in years and months
        // const yearsDiff = endDate.getFullYear() - startDate.getFullYear();
        // const monthsDiff = yearsDiff * 12 + (endDate.getMonth() - startDate.getMonth());

        // // Calculate the total days difference
        // const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // // If it's exactly 3 months, check the days difference
        // if (monthsDiff === 3) {
        //     return endDate.getDate() > startDate.getDate() || daysDiff > 90;
        // }
        // // Return true if the difference exceeds 3 months
        // return monthsDiff > 3;
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // Calculate the total days difference
        const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // If the difference exceeds 90 days, return true
        return daysDiff > 92;
    }
    const showExport = () => {
        if (!filterValue.includes('TRX_DATE')) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setTimeout(() => {
                // settitle('');
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (filterValue.includes('TRX_DATE') && isExceedingThreeMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should be between 3 months');
            setcolorValue(true);
            setTimeout(() => {
                // settitle('');
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        setexportClick(!exportClick);
    };
    const handleExport = useCallback((() => {
        distributorService.MISInvoiceReport(currentPage, sortType, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleInvoiceReport();
    }, [handleInvoiceReport]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Invoice Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => {
                            handleFetchthreepl();
                            setFilterModal(true);
                        }}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative" ref={buttonRef}>
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => showExport()}

                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] ${exportClick === true ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-3 mt-3 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-3 hov3r:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-3 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <InvoiceReportSkeleton />
                : (
                    <div>
                        {InvoiceReportList.length > 0 && (
                            <div
                                className="overflow-auto dropdown-menu pb-7 relative z-10"
                                style={{ height: 'calc(100vh - 298px)' }}
                            >
                                <table className="w-full table-auto relative">
                                    <thead className="sticky top-0 left-0 z-[2]">
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Invoice No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[168px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    E-waybill No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Customer Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Customer Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[250px] text-center">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Invoice Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'INVOICE_DATE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'INVOICE_DATE+asc') {
                                                                    setsortType('INVOICE_DATE+desc');
                                                                } else if (sortType === 'INVOICE_DATE+desc') {
                                                                    setsortType('INVOICE_DATE+asc');
                                                                } else {
                                                                    setsortType('INVOICE_DATE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Customer PO Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Order Category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Transporter Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Indent Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Order Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'ORDER_DATE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'ORDER_DATE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'ORDER_DATE+asc') {
                                                                    setsortType('ORDER_DATE+desc');
                                                                } else if (sortType === 'ORDER_DATE+desc') {
                                                                    setsortType('ORDER_DATE+asc');
                                                                } else {
                                                                    setsortType('ORDER_DATE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Order Acceptance No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[240px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Shipped from
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[208px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Shipped to
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[208px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Invoice Value
                                                    {' '}
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'TOTAL_INVOICE_AMT+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'TOTAL_INVOICE_AMT+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'TOTAL_INVOICE_AMT+asc') {
                                                                    setsortType('TOTAL_INVOICE_AMT+desc');
                                                                } else if (sortType === 'TOTAL_INVOICE_AMT+desc') {
                                                                    setsortType('TOTAL_INVOICE_AMT+asc');
                                                                } else {
                                                                    setsortType('TOTAL_INVOICE_AMT+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[212px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Payment Status
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[272px]">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Invoice Ref. No. & Comment
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[300px]">
                                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Virtual Payment Ref. No. & Comment
                                                </span>
                                            </th>
                                            <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-[5px] px-7 min-w-[60px]" />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {InvoiceReportList.length > 0 && InvoiceReportList.map((item, i) => (
                                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td
                                                    className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 flex justify-center items-center pt-4"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                >
                                                    {item?.TRX_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.WAYBILL_NUMBER === null ? '-' : item?.WAYBILL_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.CUSTOMER_CODE}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.CUSTOMER_NAME}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                    {moment(item?.INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.CUST_PO_NUMBER || '-'}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.ORDER_CATEGORY}
                                                </td>
                                                <td className="text-sm font-normal more-lines py-[5px] px-7 text-center">
                                                    {item?.TRANSPORTER_NAME === null ? '-' : item?.TRANSPORTER_NAME}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.INDENT_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {moment(item?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.ORDER_ACCEPTANCE_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.SHIP_FROM}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.SHIP_TO}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {PriceHandler(item?.INVOICE_VALUE)}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.PAYMENT_STATUS}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                    {item?.PAYMENT_NOTE
                                                        ? (
                                                            <p
                                                                className="max-w-sm truncate"
                                                                onMouseEnter={() => setNoteToolTip(`payment-${i}`)}
                                                                onMouseLeave={() => {
                                                                    setTimeout(() => {
                                                                        setNoteToolTip('');
                                                                    }, 2000);
                                                                }}
                                                            >
                                                                {item?.PAYMENT_NOTE && (item?.PAYMENT_NOTE.length > 35 ? `${item?.PAYMENT_NOTE.slice(0, 35)}...` : `${item?.PAYMENT_NOTE}`)}
                                                            </p>
                                                        )
                                                        : <p className="max-w-sm truncate text-center">-</p>}
                                                    {item?.PAYMENT_NOTE
                                                        && (
                                                            <div id="tooltip-information" role="tooltip" className={`inline-block absolute  ${noteToolTip === `payment-${i}` ? 'show' : 'invisible'}  z-10 px-0.5 py-[5px] bg-[#A5A5A5] rounded-lg shadow-s2 w-[274px]`}>
                                                                <p className="text-sm font-normal text-[#ffffff] cursor-pointer text-center break-words">
                                                                    {item?.PAYMENT_NOTE}
                                                                </p>
                                                            </div>
                                                        )}
                                                </td>
                                                <td className="text-sm font-normal max-w-sm truncate text-[#090406] py-[5px] px-7">
                                                    {item?.VIRTUAL_PAYMENT_NOTE
                                                        ? (
                                                            <p
                                                                className="max-w-sm truncate"
                                                                onMouseEnter={() => setNoteToolTip(`virtual_note-${i}`)}
                                                                onMouseLeave={() => {
                                                                    setTimeout(() => {
                                                                        setNoteToolTip('');
                                                                    }, 2000);
                                                                }}
                                                            >
                                                                {item?.VIRTUAL_PAYMENT_NOTE && (item?.VIRTUAL_PAYMENT_NOTE.length > 35 ? `${item?.VIRTUAL_PAYMENT_NOTE.slice(0, 35)}...` : `${item?.VIRTUAL_PAYMENT_NOTE}`)}

                                                            </p>
                                                        )
                                                        : <p className="max-w-sm truncate text-center">-</p>}
                                                    <div id="tooltip-information" role="tooltip" className={`inline-block absolute  ${noteToolTip === `virtual_note-${i}` ? 'show' : 'invisible'}  z-10 px-0.5 py-[5px] bg-[#A5A5A5] rounded-lg shadow-s2 w-[274px]`}>
                                                        <p className="text-sm font-normal text-[#ffffff] cursor-pointer text-center break-words">
                                                            {item?.VIRTUAL_PAYMENT_NOTE}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td
                                                    onClick={() => {
                                                        if (isEditId === i) {
                                                            setisEditId('');
                                                        } else {
                                                            setisEditId(i);
                                                        }
                                                    }}
                                                    className="py-[5px] px-7 sticky right-0 bg-[#ffffffe6] z-[1]"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                >
                                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                                    </button>
                                                    {isEditId !== '' && (
                                                        <ul className={`dropdown-menu min-w-[175px] absolute ${isEditId === i ? 'show' : 'hidden'} bg-[#FFFFFF] top-0 right-14 rounded-[10px] shadow-s2`} aria-labelledby="dropdownMenuButton111">
                                                            <li
                                                                className="px-5 pb-3 pt-3"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#view-and-download"
                                                                onClick={() => handleViewInvoiceDetails(item?.INVOICE_NO)}
                                                            >
                                                                <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="#">View and Download</a>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </td>
                                            </tr>

                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {InvoiceReportList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={InvoiceReportList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <InvoiceReportFilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                selected={selected}
                                setselected={setselected}
                                Filter={Filter}
                                setFilter={setFilter}
                                handleFilter={handleFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleInvoiceReport={handleInvoiceReport}
                                threeplList={threeplList}
                                setThreeplList={setThreeplList}
                                InvoiceReportList={InvoiceReportList}
                                SetSuccessMessage={SetSuccessMessage}
                            />
                        )}
                        {viewandDownloadModal && (
                            <ViewandDownloadModal
                                viewandDownloadModal={viewandDownloadModal}
                                setViewandDownloadModal={setViewandDownloadModal}
                                viewInvoiceDetails={viewInvoiceDetails}
                                setViewInvoiceDetails={setViewInvoiceDetails}
                            />
                        )}
                    </div>

                )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="Invoice Report"
                    buttonRequired={false}
                    all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                />
            )}

        </div>
    );
}

export default InvoiceReport;
